export const offlineMessage = "You are currently offline";
export const happyReport = "successful";
export const authMessage = {
  titleSuccess: "Good Job",
  titleError: "Authentication unsuccessful",
  userSignInError: "we were unable to validate your user credential",
};
export const projectMessage = {
  titleSuccess: "Project was created successfully",
  titleError: "Project creation unsuccessful",
  titleDelete: "Project Deleted Successfully!!",
};
export const tasksMessage = {
  titleSuccess: "Tasks were created successfully",
  titleError: "Task could not be created",
  titleDelete: "Task deleted!!!",
};

export const courseMessage = {
  titleSuccess: "Course was created successfully",
  titleError: "Course could not be created!",
  titleDelete: "Course deleted!",
};

export const userMessage = {
  titleSuccess: "User was added successfully",
  titleError: "User could not be added",
  titleDelete: "User has been removed",
};

export const studentMessage = {
  titleSuccess: "Student was added successfully",
  titleError: "Student could not be added",
  titleDelete: "Student has been removed",
};

export const liveMessage = {
  titleSuccess: "Class scheduled successfully",
  titleError: "Class not scheduled",
  titleUpdate: "Class updated",
  titleDelete: "Scheduled class has been removed",
};

export const assessmentMessage = {
  titleSuccess: "Assessment created successfully",
  titleError: "Assessment could not be created",
  titleDelete: "Assessment deleted!!",
  titleSubmit: "Assessment Submitted Successfully",
};
